export default __webpack_public_path__ + "static/media/banner_promotion.db299da0.svg";